import SurveySettingsPage from "./SurveySettingsPage";

export default SurveySettingsPage;
